export default "__VITE_ASSET__DKmrMsd7__"